import { render, staticRenderFns } from "./prdtype.vue?vue&type=template&id=53189b95&scoped=true&"
import script from "./prdtype.vue?vue&type=script&lang=js&"
export * from "./prdtype.vue?vue&type=script&lang=js&"
import style0 from "./prdtype.vue?vue&type=style&index=0&id=53189b95&scoped=true&lang=less&"
import style1 from "./prdtype.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53189b95",
  null
  
)

export default component.exports